
import Razor from '../Razorpay/Razor';
import { toast } from "react-toastify";
import { deleteData, getData, postData } from '../global/Globalapi';
import { showAlert } from '../Components/DynamicComp/Alert';



// export const handlePayment = async ({address,navigate,totalAmount,cart,phone}) => {


//   const userString = localStorage.getItem("user");

//   const user = userString ? JSON.parse(userString) : null;

//   const userId = user?.user_id;
//   const userdetails = {
//   name: user?.name,
//   email: user?.email,
//   phone: user?.mobile,
// };
//   if (!userId) {
//     toast.error("User not found. Please login.");
//     return;
//   }

//   try {
//     // const cartRes = await getData(`/cart/${userId}`);
//     // const cart = cartRes?.data || [];
//     // if (!cart.length) {
//     //   toast.warning("Cart is empty");
//     //   return;
//     // }

//     const isScriptLoaded = await Razor();
//     if (!isScriptLoaded) {
//         showAlert({
//                   type: 'error',
//                   message:'Razorpay SDK failed to load',
//                   title: 'error',
//                 });
//       return;
//     }

//     const orderRes = await postData("/create-order", { amount: totalAmount, cart ,currency:"INR"});
//      console.log("total amount in api",totalAmount)
//     const options = {
//       key: process.env.REACT_APP_RAZORPAY_KEY_ID,
//       amount: totalAmount * 100,
//       currency: "INR",
//       name: "Bolt And Brook",
//       description: "Product Purchase",
//       order_id: orderRes.id,
//       handler: async function (response) {
//          console.log("address",address);
//         toast.success("Payment successful!");
//         const paymentdata= await postData("/save-payment", {
//           payment_id: response.razorpay_payment_id,
//         });           
//          console.log("userid",userId);
//          console.log("atlast order",orderRes);
//          console.log("atlast payment response",paymentdata);
//          const payload={
//             user_id: userId,
//             order_id: orderRes?.data?.id,
//             payment_id: paymentdata?.data?.payment.id,
//             amount: totalAmount,
//             address: address,
//             phone:phone,
//             cart: cart.map(item => ({
//               product_id: item.child_id ?? item.product_id,
//               quantity: item.quantity,
//               amount: item.amount}))
//          }
//          console.log("payload",payload);
//          const saveresponse= await postData("/save-orders", payload);
//          const del=await deleteData(`/cart/${userId}`);
//          console.log("del",del);
//          console.log("save response",saveresponse);
//          navigate.Gobanner("/",{
//             Message:"Order Completed Successfully",
//             OrderedItems:cart,
//             TotalAmount:totalAmount     
//          })
//       },
//       prefill: {
//         name: userdetails.name,
//         email: userdetails.email,
//         contact: phone ,
//       },
//       notes: {
//         address: address,
//         greetings: "Thanks for shopping",
//       },
//       theme: {
//         color: "#ff0000",
//       },
//     };

//     const rzp = new window.Razorpay(options);
//     rzp.open();
//   } catch (err) {
//     console.error("Payment error:", err);
//         showAlert({
//         type: 'error',
//         message: err.message || 'Payment failed.',
//         title: 'Error',
//     });
//     // toast.error("Payment failed.");
//   }
// };



// under Process
// export const handlePayment = async ({ address, navigate, totalAmount, cart, phone, orderId }) => {

//   const user = JSON.parse(localStorage.getItem("user"));
//   const userId = user?.user_id;

//   if (!userId) {
//     toast.error("Please login");
//     return;
//   }

//   // const orderId = "ORD-" + Date.now(); // ✅ YOUR ORDER ID
// // const finalOrderId = orderId || ("ORD-" + Date.now());
// const finalOrderId = orderId ? orderId : "ORD-" + Date.now();

// console.log("Final Order ID:", finalOrderId);
//   try {
//     /* ========================
//        1️⃣ SAVE ORDER FIRST
//     ======================== */
//     // await postData("/save-orders", {
//     //   user_id: userId,
//     //   order_id: orderId,
//     //   address,
//     //   phone,
//     //   cart: cart.map(item => ({
//     //     product_id: item.child_id ?? item.product_id,
//     //     quantity: item.quantity,
//     //     amount: item.amount
//     //   }))
//     // });
// await postData("/save-orders", {
//   user_id: userId,
//   order_id: finalOrderId,
//   address,
//   phone,
//   cart: cart.map(item => ({
//     product_id: item.child_id ?? item.product_id,
//     quantity: item.quantity,
//     amount: item.amount
//   }))
// });

//     /* ========================
//        2️⃣ LOAD RAZORPAY
//     ======================== */
//     const loaded = await Razor();
//     if (!loaded) {
//       toast.error("Razorpay failed to load");
//       return;
//     }

//     /* ========================
//        3️⃣ OPEN RAZORPAY
//     ======================== */
//     console.log("key:", process.env.REACT_APP_RAZORPAY_KEY_ID);
//     const options = {
//       key: process.env.REACT_APP_RAZORPAY_KEY_ID,
//       amount: totalAmount * 100,
//       currency: "INR",
//       name: "Malar's Bakers",
//       description: "Product Purchase",

// //       handler: async (response) => {
// //  console.log("Razorpay API Response:", response);
// //         /* ========================
// //            4️⃣ UPDATE PAYMENT
// //         ======================== */
// //         await postData("/update-payment", {
// //           order_id: orderId,                       // ✅ YOUR ORDER ID
// //           payment_id: response.razorpay_payment_id,
// //           payedamount: totalAmount
// //         });

// //         await deleteData(`/cart/${userId}`);

// //         toast.success("Payment successful");

// //         navigate.Gobanner("/", {
// //           Message: "Order Completed Successfully",
// //           OrderedItems: cart,
// //           TotalAmount: totalAmount
// //         });
// //       },
// handler: async (response) => {
//   console.log("Razorpay API Response:", response);

//   /* ========================
//      UPDATE PAYMENT
//   ======================== */
//   // await postData("/update-payment", {
//   //   order_id: orderId,
//   //   payment_id: response.razorpay_payment_id,
//   //   payedamount: totalAmount
//   // });
// await postData("/update-payment", {
//   order_id: finalOrderId,
//   payment_id: response.razorpay_payment_id,
//   payedamount: totalAmount
// });

//   /* ========================
//      🔹 BUILD PAYLOAD (FIXED)
//   ======================== */
//   const payload = {
//     user_id: userId,
//     order_id: finalOrderId, // ✅ use existing orderId
//     payment_id: response.razorpay_payment_id, // ✅ Razorpay response
//     amount: totalAmount,
//     address: address,
//     phone: phone,
//     cart: cart.map(item => ({
//       product_id: item.child_id ?? item.product_id,
//       quantity: item.quantity,
//       amount: item.amount
//     }))
//   };

//   /* ========================
//      🔹 BUILD INVOICE PAYLOAD
//   ======================== */
//   // const invoicePayload = {
//   //   orderId: payload.order_id,
//   //   billingAddress: payload.address,
//   //   shippingAddress: payload.address,
//   //   paymentMode: "UPI",
//   //   items: cart.map(item => ({
//   //     name: item.product_name || item.name || "Product",
//   //     price: Number(item.amount),
//   //     quantity: Number(item.quantity)
//   //   }))
//   // };
// const invoicePayload = {
//   orderId: finalOrderId,
//   billingAddress: address,
//   shippingAddress: address,
//   paymentMode: "UPI",
//   items: cart.map(item => ({
//     name: item.product_name || item.name || "Product",
//     price: Number(item.amount),
//     quantity: Number(item.quantity)
//   }))
// };

//   /* ========================
//      🔹 GENERATE INVOICE
//   ======================== */
//   // await postData("/orders/generate-invoice", invoicePayload);
//   postData("/orders/generate-invoice", {
//   invoicePayload
// });


//   /* ========================
//      FINAL CLEANUP
//   ======================== */
//   await deleteData(`/cart/${userId}`);

//   toast.success("Payment successful");

//   navigate.Gobanner("/", {
//     Message: "Order Completed Successfully",
//     OrderedItems: cart,
//     TotalAmount: totalAmount
//   });
// }
// ,
//       prefill: {
//         name: user.name,
//         email: user.email,
//         contact: phone
//       },

//       theme: { color: "#ff0000" }
//     };

//     new window.Razorpay(options).open();

//   } catch (err) {
//     console.error(err);
//     toast.error("Something went wrong");
//   }
// };




// duplicate payment id
const ENABLE_RAZORPAY = false; // 🔴 TURN OFF RAZORPAY UI

export const handlePayment = async ({
  address,
  navigate,
  totalAmount,
  cart,
  phone,
  orderId
}) => {

  const user = JSON.parse(localStorage.getItem("user"));
  const userId = user?.user_id;

  if (!userId) {
    toast.error("Please login");
    return;
  }

  // const finalOrderId = orderId ? orderId : "ORD-" + Date.now();
//   const generateOrderId = () => {
//   const now = new Date();

//   const yy = String(now.getFullYear()).slice(-2);
//   const mm = String(now.getMonth() + 1).padStart(2, "0");
//   const dd = String(now.getDate()).padStart(2, "0");

//   const datePrefix = `${yy}${mm}${dd}`;

//   const stored = JSON.parse(localStorage.getItem("daily_order_counter")) || {};

//   let count = 1;

//   if (stored.date === datePrefix) {
//     count = Number(stored.count || 0) + 1;
//   }

//   localStorage.setItem(
//     "daily_order_counter",
//     JSON.stringify({
//       date: datePrefix,
//       count: count
//     })
//   );

//   return `${datePrefix}${String(count).padStart(5, "0")}`;
// };
let finalOrderId = orderId || null;
console.log("Initial Order ID:", finalOrderId);
// const finalOrderId = orderId ? orderId : generateOrderId();
  // console.log("Final Order ID:", finalOrderId);

  try {
    /* ========================
       1️⃣ SAVE ORDER FIRST
    ======================== */
    // await postData("/save-orders", {
    //   user_id: userId,
    //   order_id: finalOrderId,
    //   address,
    //   phone,
    //   cart: cart.map(item => ({
    //     product_id: item.child_id ?? item.product_id,
    //     quantity: item.quantity,
    //     amount: item.amount
    //   }))
    // });
//     const dummyPaymentId = `dummy_rzp_${Date.now()}`;
// const saveResponse = await postData("/save-orders", {
//   user_id: userId,
//   address,
//   phone,
//   cart: cart.map(item => ({
//     product_id: item.child_id ?? item.product_id,
//     quantity: item.quantity,
//     amount: item.amount
//   }))
// });
const dummyPaymentId = `dummy_rzp_${Date.now()}`;

const saveResponse = await postData("/save-orders", {
  user_id: userId,
  address,
  phone,
  payment_id: !ENABLE_RAZORPAY ? dummyPaymentId : undefined,
  payedamount: !ENABLE_RAZORPAY ? totalAmount : 0,
  status: !ENABLE_RAZORPAY ? "Success" : "Pending",
  cart: cart.map(item => ({
    product_id: item.child_id ?? item.product_id,
    quantity: item.quantity,
    amount: item.amount
  }))
});
finalOrderId = saveResponse?.data?.order_id;

if (!finalOrderId) {
  toast.error("Order ID not received");
  return;
}

console.log("Final Order ID from backend:", finalOrderId);
    /* ========================
       🚫 RAZORPAY BLOCKED
       ✅ DUMMY PAYMENT SUCCESS
    ======================== */
    if (!ENABLE_RAZORPAY) {
      // const dummyPaymentId = `dummy_rzp_${Date.now()}`;

      // ✅ update payment (NO backend change)
      // await postData("/update-payment", {
      //   order_id: finalOrderId,
      //   payment_id: dummyPaymentId,
      //   payedamount: totalAmount
      // });
await postData("/orders/send-order-sms", {
  mobile_number: phone,
  order_id: finalOrderId,
  amount: totalAmount,
  delivery_type: address.includes("TAKEAWAY")
    ? "TAKEAWAY"
    : address.includes("SAFEDELIVERY")
    ? "SAFEDELIVERY"
    : "HOME",
  delivery_charge: Number(totalAmount) - Number(
    cart.reduce((sum, item) => sum + Number(item.amount || 0), 0)
  )
});

      // ✅ invoice generation (same logic)
      // await postData("/orders/generate-invoice", {
      //   orderId: finalOrderId,
      //   billingAddress: address,
      //   shippingAddress: address,
      //   paymentMode: "DUMMY",
      //   items: cart.map(item => ({
      //     name: item.product_name || item.name || "Product",
      //     price: Number(item.amount),
      //     quantity: Number(item.quantity)
      //   }))
      // });

      // ✅ cleanup
      await deleteData(`/cart/${userId}`);

      toast.success("Order Placed");

      navigate.Gobanner("/", {
        Message: "Order Completed Successfully",
        OrderedItems: cart,
        TotalAmount: totalAmount
      });

      return; // ⛔ STOP — Razorpay will not open
    }

    /* ========================
       2️⃣ LOAD RAZORPAY
    ======================== */
    const loaded = await Razor();
    if (!loaded) {
      toast.error("Razorpay failed to load");
      return;
    }

    /* ========================
       3️⃣ OPEN RAZORPAY
    ======================== */
    const options = {
      key: process.env.REACT_APP_RAZORPAY_KEY_ID,
      amount: totalAmount * 100,
      currency: "INR",
      name: "Malar's Bakers",
      description: "Product Purchase",

      handler: async (response) => {
        console.log("Razorpay API Response:", response);

        await postData("/update-payment", {
          order_id: finalOrderId,
          payment_id: response.razorpay_payment_id,
          payedamount: totalAmount
        });

        // await postData("/orders/generate-invoice", {
        //   orderId: finalOrderId,
        //   billingAddress: address,
        //   shippingAddress: address,
        //   paymentMode: "UPI",
        //   items: cart.map(item => ({
        //     name: item.product_name || item.name || "Product",
        //     price: Number(item.amount),
        //     quantity: Number(item.quantity)
        //   }))
        // });

        await deleteData(`/cart/${userId}`);

        toast.success("Payment successful");

        navigate.Gobanner("/", {
          Message: "Order Completed Successfully",
          OrderedItems: cart,
          TotalAmount: totalAmount
        });
      },

      prefill: {
        name: user.name,
        email: user.email,
        contact: phone
      },

      theme: { color: "#ff0000" }
    };

    new window.Razorpay(options).open();

  } catch (err) {
    console.error(err);
    toast.error("Something went wrong");
  }
}